// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-medium":"#5e5e5e","fieldset":"_26AQnlR","fadeIn":"U5VdaHB","cancel":"_0caFK6","button":"_1NqYH0o"};